import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AutocompleteFunction } from '../../../../core/common/entities/autocompleteFunction.entity';
import { FormSelectOption } from '../../../entities/form-select-option.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormTypedValueListComplexBaseComponent } from '../base-complex/form-typed-value-list-complex-base.component';
import { ShFormTypedValueListBaseComponent } from '../base-simple/form-typed-value-list-base.component';

@Component({
    selector: 'sh-form-typed-value-list',
    templateUrl: './form-typed-value-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ShFormGroupComponent,
        ShFormTypedValueListComplexBaseComponent,
        ReactiveFormsModule,
        ShFormTypedValueListBaseComponent,
        AsyncPipe
    ]
})
export class ShFormTypedValueListComponent extends ShBaseFormComponent {
    @Input() types: FormSelectOption[] = [];
    @Input() typePlaceholderMsg = '';
    @Input() valuePlaceholderMsg = '';
    @Input() autocompleteFcts?: Record<string, AutocompleteFunction>;
}
